import React from 'react';
import { Slide } from '@material-ui/core';

export const SlideUp = React.memo(React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />));

export const SlideDown = React.memo(React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />));
